import { Button, ButtonProps, styled } from "@mui/material";
import React from "react";

const StyledButton = styled(Button)(({ theme }) => ({
  color: theme.palette.mode === "dark" ? "#E7E7E7" : "#000000",
  fontWeight: "normal",
  textTransform: "none",
  textDecoration: "underline",

  "&:hover": {
    backgroundColor: "transparent",
  },
}));

export const LinkButton = (props: Omit<ButtonProps, "disableRipple">) => (
  <StyledButton disableRipple {...props} />
);
